import { log as pilog } from "@limitless/common/utils";
import format from "date-fns/format";
export const findUserCountry = (profile, countryList) => {
  const log = pilog.getLogger("AboutFormHelper findUserCountry");
  const country = {
    value: "Profile Incomplete",
    isSocialEnabled: false
  };
  const userCountry = countryList.find(country => {
    return profile.country === country.countryCode && profile.language === country.languageCode;
  });
  if (!userCountry) {
    return country;
  }
  country.value = `${userCountry.countryDescription} - ${userCountry.languageDescription}`;
  if (userCountry.socialSecurityNoEnabled && userCountry.socialSecurityNoEnabled === true && userCountry.socialSecurityNoFormat) {
    try {
      country.isSocialEnabled = true;
      country.socialSecurityMask = userCountry.socialSecurityNoFormat;
      country.socialSecurityNo = profile.socialSecurityNo;
      country.socialSecurityMaskLen = userCountry.socialSecurityNoFormat.replace(/[^\w\s]/gi, "").length;
    } catch (error) {
      log.warn(`Incorrect Social Security configuration for ${userCountry.countryDescription}`, error);
    }
  }
  return country;
};
export const getUserSocialSecurity = country => {
  return {
    ...country,
    value: country.socialSecurityNo,
    pristine: true
  };
};
const getFormatedDob = date => {
  const dateValue = new Date(date);
  const timeZoneDate = new Date(dateValue.valueOf() + dateValue.getTimezoneOffset() * 60 * 1000);
  return format(timeZoneDate, "YYYY-MM-DD");
};
export const getUserDob = profile => {
  return {
    value: profile.dob,
    // eslint-disable-next-line no-undefined
    formattedValue: !(profile.dob === null || profile.dob === undefined) ? getFormatedDob(profile.dob) : "",
    pristine: true
  };
};